import {Loading} from 'element-ui';

let loadingCount = 0;
let loading;
const startLoading = () => {
  loading = Loading.service({
    lock: true,
    text: "加載中,请稍后",
    background: 'rgba(0, 0, 0, 0.7)'
  });
  setTimeout(() => {
    loading.close();
  }, 60000);
};

const endLoading = () => {
  loading.close();
};

export const showLoading = (title) => {
  if (loadingCount === 0) {
    startLoading(title);
  }
  loadingCount += 1;
};

export const hideLoading = () => {
  if (loadingCount <= 0) {
    return;
  }
  loadingCount -= 1;
  if (loadingCount === 0) {
    endLoading();
  }
};



// WEBPACK FOOTER //
// ./src/api/loading.js